
























import { Component, Prop, Vue } from 'vue-property-decorator'

type AvailableModes = 'error'
type AvailableSizes = 'normal' | 'small'
@Component({
  name: 'notifications-list-state',
})
export default class NotificationsListStateComponent extends Vue {
  @Prop() text!: string
  @Prop() secondaryText!: string
  @Prop({ default: false }) hideBackground!: boolean
  @Prop({ default: 'normal' }) size!: AvailableSizes
  @Prop() mode!: AvailableModes
}
